import { useQuery } from '@tanstack/react-query';
import { organizationsApi } from '@/api/organizations.api';
import type { OrganizationResponse } from '@/types/organization';

export const CURRENT_ORG_QUERY_KEY = ['organization', 'me'] as const;

/**
 * Loads the signed-in tenant organization once per session (cached).
 * Call `refetch` after profile updates; invalidates on full page refresh via cache clear.
 */
export function useCurrentOrganization(enabled = true) {
  return useQuery({
    queryKey: CURRENT_ORG_QUERY_KEY,
    queryFn: () => organizationsApi.getCurrent(),
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: 30 * 60_000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

export function resolveCountryCode(
  org: OrganizationResponse,
  countries: { code: string; label: string }[],
): string {
  if (org.countryCode) return org.countryCode;
  const byLabel = countries.find((c) => c.label === org.country);
  if (byLabel) return byLabel.code;
  const byCode = countries.find((c) => c.code === org.country);
  return byCode?.code ?? '';
}
